import { Phone } from "lucide-react";
import { SITE } from "@/siteConfig";
import { useQuote } from "./QuoteModal";
import { useContent } from "@/content/ContentContext";

export default function MobileBottomBar() {
  const { openQuote } = useQuote();
  const { get } = useContent();
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-line bg-white/95 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={get("site_phone_href", SITE.phoneHref)}
        data-testid="mobile-call-button"
        className="flex min-h-[56px] items-center justify-center gap-2 text-sm font-bold tracking-[0.08em] text-charcoal transition-colors duration-200 active:bg-sand"
      >
        <Phone className="h-4 w-4" aria-hidden="true" />
        CALL
      </a>
      <button
        type="button"
        onClick={() => openQuote()}
        data-testid="mobile-quote-button"
        className="flex min-h-[56px] items-center justify-center bg-ember text-sm font-bold tracking-[0.08em] text-charcoal transition-colors duration-200 active:bg-ember-dark active:text-white"
      >
        GET A QUOTE
      </button>
    </div>
  );
}
